var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon.includes('push-status'))?_c('IconsPushStatus',{attrs:{"icon":_vm.icon,"color":_vm.color,"width":_vm.width,"height":_vm.height}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }